import { formUrl } from './links/form-url'

const isEmptyString = (value: string | number) => value.toString().length === 0

export const getWorkflowEditorUrl = (id: number | string) =>
  !isEmptyString(id) ? formUrl(`/workflow/${id}/edit`) ?? '' : ''

export const getWorkflowEditorUrlWithStep = (id: number | string, stepId: number | string) =>
  !isEmptyString(id) && !isEmptyString(stepId) ? getWorkflowEditorUrl(id) + '?step=' + stepId : ''
